/**
 * Ordre de niveau des catégories seniors (championnats par équipes district / département).
 * Les catégories absentes de cette liste restent en fin de liste, tri alphabétique.
 */
export const TEAM_SENIOR_SERIES_CATEGORY_ORDER = [
	'EXCELLENCE',
	'HONNEUR',
	'PROMOTION',
	'PROMOTION A',
	'PROMOTION B',
	'ESSOR',
	'ESSOR A',
	'ESSOR B',
	'ESSOR C',
	'ESSOR D',
	'ESPOIR',
	'ESPOIR A',
	'ESPOIR B',
	'PREMIERE SERIE',
	'DEUXIEME SERIE',
	'TROISIEME SERIE',
	'QUATRIEME SERIE',
	'CINQUIEME SERIE',
	'SIXIEME SERIE',
	'SEPTIEME SERIE',
];

const TEAM_SENIOR_SERIES_RANK = new Map(
	TEAM_SENIOR_SERIES_CATEGORY_ORDER.map((category, index) => [category, index]),
);

export function sortTeamSeniorSeriesCategories(categories) {
	return [...categories].sort((a, b) => {
		const rankA = TEAM_SENIOR_SERIES_RANK.get(a);
		const rankB = TEAM_SENIOR_SERIES_RANK.get(b);
		const hasA = rankA !== undefined;
		const hasB = rankB !== undefined;

		if (hasA && hasB) return rankA - rankB;
		if (hasA) return -1;
		if (hasB) return 1;
		return a.localeCompare(b, 'fr');
	});
}

/** Ordre des catégories — championnats INDIVIDUEL (fichier individuel). */
export const INDIVIDUEL_CATEGORY_ORDER = [
	'POUSSINES',
	'POUSSINS',
	'BENJAMINES',
	'BENJAMINS',
	'ADOLESCENTES 15',
	'MINIMES',
	'CADETS',
	'ADOLESCENTES 18',
	'JUNIORS',
	'FEMININES SENIORS',
	'FEMININES SENIORS JB',
	'FEMININES SENIORS JA/J*',
	'FEMININES SENIORS JA',
	'FEMININES SENIORS J*',
	'FEMININES SENIORS ESPOIR',
	'FEMININES SENIORS MJ',
	'SENIORS',
	'SENIORS JB',
	'SENIORS JA',
	'SENIORS J*',
	'SENIORS ESPOIR',
	'SENIORS ETOILE',
	'SENIORS MJ',
	'PARIS IND J.F.V',
	'PARIS IND SH ESPOIR',
	'PARIS IND SH PROM',
	'PARIS IND SH HON',
	'PARIS IND SH EXC',
];

const INDIVIDUEL_CATEGORY_RANK = new Map(
	INDIVIDUEL_CATEGORY_ORDER.map((category, index) => [category, index]),
);

export function sortIndividuelCategories(categories) {
	return [...categories].sort((a, b) => {
		const rankA = INDIVIDUEL_CATEGORY_RANK.get(a);
		const rankB = INDIVIDUEL_CATEGORY_RANK.get(b);
		const hasA = rankA !== undefined;
		const hasB = rankB !== undefined;

		if (hasA && hasB) return rankA - rankB;
		if (hasA) return -1;
		if (hasB) return 1;
		return a.localeCompare(b, 'fr');
	});
}
